import { RouteComponentProps } from '@reach/router';
import { useTimeoutPrompt } from 'helpers/useTimeoutPrompt';
import React from 'react';

const SessionTimeout: React.FC<RouteComponentProps> = ({ location }) => {
  useTimeoutPrompt();
  return <></>;
};

export default SessionTimeout;
